import {
  DepositProductUnavailablePage,
  LoadingPage,
} from '@resurs-internal/deposits-app-components';
import { CountryContext } from 'contexts/CountryContext';
import { useProducts } from 'hooks/useProducts';
import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ErrorView } from 'views/errorView';

import { useCampaignCode } from '@/hooks';

export const MaxAccountsView = () => {
  const navigate = useNavigate();
  const { country } = useContext(CountryContext);
  const { isLoading, products } = useProducts(country);
  const { appendCampaignCode, createParamsWithCampaignCode } =
    useCampaignCode();

  const { productCode } = useParams();
  const suggestedProduct = products?.find(
    (product) => product.code !== productCode,
  );
  const unavailableProduct = products?.find(
    (product) => product.code === productCode,
  );

  const navigateProductChoice = () => {
    if (!productCode) {
      navigate(appendCampaignCode('/choose-account-type'));

      return;
    }
    const params = createParamsWithCampaignCode({
      unavailableProductCode: productCode,
    });

    navigate(`/choose-account-type?${params.toString()}`);
  };

  const navigateSuggestedProduct = () => {
    const params = createParamsWithCampaignCode({
      state: suggestedProduct?.code || '',
    });

    navigate(`/application?${params.toString()}`);
  };

  if (isLoading) return <LoadingPage country={country} />;

  if (suggestedProduct !== undefined && unavailableProduct) {
    return (
      <DepositProductUnavailablePage
        navigateProductChoice={navigateProductChoice}
        navigateSuggestedProduct={navigateSuggestedProduct}
        suggestedProduct={suggestedProduct}
        unavailableProduct={unavailableProduct}
      />
    );
  }

  return <ErrorView code={'500'} />;
};
